import React from 'react';

import { observer } from 'mobx-react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import classNames from 'classnames';
import { GroupData, ResponseItem, RoutesMonitoringResponse } from '@bringg/types';
import { Button } from '@bringg/react-components';

import styles from './view-item-button.module.scss';

interface ViewTaskButtonProps {
	onClick: (id: number | string, isInView: boolean) => void;
	item: RoutesMonitoringResponse | ResponseItem | GroupData;
	isInView: boolean;
	loading?: boolean;
}

const ViewItemButton = ({ onClick, item: genericItem, isInView, loading }: ViewTaskButtonProps) => {
	const item = {
		...genericItem,
		id: genericItem.id
	};

	return (
		<Button
			onClick={() => onClick(item.id as number | string, !isInView)}
			type="ghost"
			className={styles.eyeButton}
			data-test-id={`show-${item.id}`}
			disabled={loading}
		>
			{loading ? (
				<BringgIcon iconName={BringgFontIcons.Loader} spin />
			) : (
				<BringgIcon
					iconName={isInView ? BringgFontIcons.Eye : BringgFontIcons.EyeOff}
					className={classNames({ [styles.hide]: !isInView })}
					data-test-id={isInView ? 'selectedItem' : 'nonSelectedItem'}
				/>
			)}
		</Button>
	);
};

export default observer(ViewItemButton);
